import { BASE } from "./index";
import axios from "./http";

const product = {
    //筛选条件
    productfilterlist: (params) =>axios.post(`${BASE.PRO1}/audit/product/filter/list`,  params ),
    //商品列表
    productcidlist: (params) =>axios.post(`${BASE.PRO1}/audit/product/cid/list`,  params ),
    //商品列表
    producttotal: (params) =>axios.post(`${BASE.PRO1}/audit/product/total`,  params ),
    //商品列表
    controllist: (params) =>axios.post(`${BASE.PRO1}/fleet/quality/control/list`,  params ),
    //城市仓迁移日志-251201
    memberlogs: (params) =>axios.post(`${BASE.PRO1}/logistics/move/member/logs`,  params ),
};

export default product;
